module.exports = __webpack_public_path__ + "Jack Yi-9697e416.png";